var RequestsManager = function(){

  var requestsMap = {};


  this.newRequest = function(requestKey, ajaxData, abortable) {
    //TODO this solution may have to be reviews, but some requests should not be aborted
    abortable = abortable !== false;
    if(requestsMap.hasOwnProperty(requestKey) && requestsMap[requestKey] != null && abortable) {
      requestsMap[requestKey].abort();
    }

    var request = $.ajax(ajaxData);
    requestsMap[requestKey] = request;

    var requestData = request.then(function(data) {
      requestsMap[requestKey] = null;
      return data;
    }).fail(_.bind(function(jqXHR, textStatus, textError) {
      console.log('Error: ' + textError);
    }, this));

    return requestData;
  };
};


var requestsSingleton = new RequestsManager();
module.exports = requestsSingleton;